var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragHandle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 8.33293H3.33333C3.11232 8.33293 2.90036 8.24513 2.74408 8.08885C2.5878 7.93257 2.5 7.72061 2.5 7.49959C2.5 7.27858 2.5878 7.06662 2.74408 6.91034C2.90036 6.75406 3.11232 6.66626 3.33333 6.66626H16.6667C16.8877 6.66626 17.0996 6.75406 17.2559 6.91034C17.4122 7.06662 17.5 7.27858 17.5 7.49959C17.5 7.72061 17.4122 7.93257 17.2559 8.08885C17.0996 8.24513 16.8877 8.33293 16.6667 8.33293ZM17.5 12.4996C17.5 12.2786 17.4122 12.0666 17.2559 11.9103C17.0996 11.7541 16.8877 11.6663 16.6667 11.6663H3.33333C3.11232 11.6663 2.90036 11.7541 2.74408 11.9103C2.5878 12.0666 2.5 12.2786 2.5 12.4996C2.5 12.7206 2.5878 12.9326 2.74408 13.0888C2.90036 13.2451 3.11232 13.3329 3.33333 13.3329H16.6667C16.8877 13.3329 17.0996 13.2451 17.2559 13.0888C17.4122 12.9326 17.5 12.7206 17.5 12.4996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandle);
export default __webpack_public_path__ + "static/media/dragHandle.88cde8b7e4b844bfb5c64fb31b5c1a1f.svg";
export { ForwardRef as ReactComponent };